export default {
	0: "none",
	1: "openExternalBrowser",
	2: "openInternalBrowser"
};
